import { render, staticRenderFns } from "./GetnetPedido.vue?vue&type=template&id=1363ab0c&scoped=true"
import script from "./GetnetPedido.vue?vue&type=script&lang=js"
export * from "./GetnetPedido.vue?vue&type=script&lang=js"
import style0 from "./GetnetPedido.vue?vue&type=style&index=0&id=1363ab0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363ab0c",
  null
  
)

export default component.exports